import { getModuleRootPath, killEmptyPath } from '@/pages/platform-marketing-position/detail/material-pool-manage/util';
import { formatUrl, filterConditions } from '@/common/utils';

function activityList() {
  return `/activity-manage/list`;
}
//活动管理-活动数据查看页面
function toActivityManageProSalesData(planCode: string) {
  return `/activity-manage/proSalesData?planCode=${planCode}`;
}
// 数据看板 ------------------------------------------
// // 活动参与效果 --- 活动详情
// function toDataPanelParticipantDataActivityDetail(params: any) {
//   const { planCode, planName, activityStartTime, activityEndTime, activityStatus, planPercent } = params;
//   return formatUrl({
//     pathname: '/data-panel/participant-data/activity-detail',
//     params: {
//       planCode,
//       planName,
//       activityStartTime,
//       activityEndTime,
//       activityStatus,
//       planPercent,
//     },
//   });
// }
//数据看板 实时数据
function toDataPanelRealTimeData(planCode: string) {
  return `/data-panel/real-time-data?activityCode=${planCode}`;
}
// 数据看板-分析报告-生成报告
function toDataPanelAnalysisReport(
  planCode: string,
  activityName: string,
  activityStartTime: string,
  activityEndTime: string,
  roomName: string
) {
  return `/data-panel/analysis-report/edit-report?planCode=${planCode}&activityName=${activityName}&activityStartTime=${activityStartTime}&activityEndTime=${activityEndTime}&roomName=${roomName}`;
}
// 数据看板-会场流程数据-列表页
function toDataPanelRoomFlowDataList() {
  return `/data-panel/flow-data/activityData?hideTab=1`;
}
// 数据看板-会场流程数据-详情页
function toDataPanelRoomFlowDataDetail(id: string | number, dataSource: string | number) {
  return `/data-panel/flow-data/activityData/detail?id=${id}&userType=${dataSource}&activityStatus=1&hideTab=1`;
}

// 招商活动下的各种路径 ----------------------------------------------------------
// 创建招商活动
function merchantActivityCreate() {
  return `/activity-manage/merchants/create`;
}
// 招商活动编辑
function merchantActivityEdit(planCode: string, step: string) {
  const stepext = step ? '&step=' + step : '';
  return `/activity-manage/merchants/create?planCode=${planCode}${stepext}`;
}
// 招商活动详情页
function merchantActivityDetail(planCode: string) {
  return `/activity-manage/merchants/detail?planCode=${planCode}`;
}
// 招商活动信息展示页
function merchantActivityDetailInfo(planCode: string) {
  return `/activity-manage/merchants/info?planCode=${planCode}`;
}
// 招商活动详情-主推盘品货
function merchantActivityInventory(planCode: string) {
  return `/activity-manage/merchants/detail/inventory?planCode=${planCode}`;
}
// 招商活动详情-招商底池
function merchantActivityWare(planCode: string) {
  return `/activity-manage/merchants/detail/ware?planCode=${planCode}`;
}
// 招商活动详情-我的商品
function merchantActivityMyWare(planCode: string, tab?: string | number) {
  return formatUrl({
    pathname: '/activity-manage/merchants/detail/myWare',
    params: filterConditions({ planCode, tab }),
  });
}
// 招商活动详情-会场活动
function merchantRoomMyCreate(planCode: string) {
  return `/activity-manage/merchants/detail/room/myCreate?planCode=${planCode}`;
}
// 招商详情-促销活动
function merchantPromotionMyCreate(planCode: string) {
  return `/activity-manage/merchants/detail/promotion/myCreate?planCode=${planCode}`;
}
// 我管理的官方会场池
function merchantMyJoinVenue(planCode: string) {
  return `/activity-manage/merchants/detail/room/myJoinVenue?planCode=${planCode}`;
}

// 会场活动-会场收品-我参与的收品池
function merchantVenueDetailPoolList(params: any) {
  return formatUrl({ pathname: '/activity-manage/merchants/venueDetail/poolList', params });
}
// 促销活动-去综促报名
function merchantPromotionToZongcuSignUp(params: any) {
  return formatUrl({
    pathname: '/activity-manage/merchants/detail/promotion/myJoin/detail/activityEnroll/detail',
    params,
  });
}

// ---------------------------------------------------------------------------
// 主题营销活动详情页
function promotionActivityDetail(planCode: string) {
  return `/activity-manage/detail?planCode=${planCode}`;
}

// 活动详情商品池
function promotionActivityDetailCommodityPool(planCode: string) {
  return `/activity-manage/detail/commodity-pool-manage?planCode=${planCode}`;
}

function promotionActivityDetailInfo(planCode: string) {
  return `/activity-manage/activity-detail?planCode=${planCode}`;
}

function promotionActivityCreate() {
  return `/activity-manage/create`;
}

function promotionActivityEdit(planCode: string) {
  return `/activity-manage/create?planCode=${planCode}`;
}

interface StartZpParamsType {
  planCode: string;
  mainPoolId: string;
  shopPoolId: string;
  activityName: string;
}

function promotionNiePanStartZP({ planCode, mainPoolId, shopPoolId, activityName }: StartZpParamsType) {
  return `/activity-manage/detail/commodity-pool-manage/collection?name=${activityName}&mainPoolId=${mainPoolId}&shopPoolId=${shopPoolId}&planCode=${planCode}`;
}

// 大促活动的征品详情
function promotionNiePanZPDetail(planCode: string, activityId: string /* 征品活动ID */) {
  return `/activity-manage/detail/commodity-pool-manage/collection?planCode=${planCode}&activityId=${activityId}`;
}

// 会场详情
function promotionVenueDetail(planCode: string, towerId: string) {
  return `/activity-manage/detail/act-manage/act-room/venueDetail?towerId=${towerId}&planCode=${planCode}`;
}

// 会场列表
function promotionVenue(planCode: string) {
  return `/activity-manage/detail/act-manage/act-room/activityVenue?planCode=${planCode}`;
}

// 会场提报创建收品池
function promotionTiBaoVenueCreate(extPathname: string) {
  return `/activity-manage/detail/act-manage/act-room/page${extPathname}`;
}

// 会场提报设置收品池
function promotionTiBaoVenueEdit(extPathname: string) {
  return `/activity-manage/detail/act-manage/act-room/page${extPathname}`;
}

// 会场提报资质设置
function promotionTiBaoQuaSetting(extPathname: string) {
  return `/activity-manage/detail/act-manage/act-room/qua/page${extPathname}`;
}

// 会场提报场次设置
function promotionTiBaoVenueSetting(extPathname: string) {
  return `/activity-manage/detail/act-manage/act-room/list${extPathname}`;
}

// 子活动管理/综促活动
function promotionZCActivity(planCode: string) {
  return `/activity-manage/detail/act-manage/zongcu?planCode=${planCode}`;
}

// 创建综促活动
function promotionCreateZCActivity(planCode: string, activityType: string) {
  return `/activity-manage/detail/act-manage/zongcu/create/activityManage/create?activity_type=${activityType}&planCode=${planCode}`;
}

function promotionZCQualificationSetting(planCode: string, activityId: string) {
  return `/activity-manage/detail/act-manage/zongcu/zongcuDetail/activityManage/qualificationSetting?activity_id=${activityId}&planCode=${planCode}`;
}

function promotionZCResourceAllocation(planCode: string, activityId: string) {
  return `/activity-manage/detail/act-manage/zongcu/zongcuDetail/activityManage/resourceAllocation?activity_id=${activityId}&planCode=${planCode}`;
}

function promotionZCResourceDetail(planCode: string, activityId: string) {
  return `/activity-manage/detail/act-manage/zongcu/zongcuDetail/activityManage/detail?activity_id=${activityId}&flow_type=0&planCode=${planCode}`;
}

// 去到素材底池新建
function promotionMaterialPoolSet(planCode: string) {
  return `/activity-manage/detail/act-manage/act-room/materialPoolSet?planCode=${planCode}`;
}

function promotionMaterialPoolEdit(planCode: string) {
  return `/activity-manage/detail/act-manage/act-room/materialPoolEdit?planCode=${planCode}`;
}

function promotionMaterialManage(planCode: string) {
  return `/activity-manage/detail/act-manage/act-room/materialManage?planCode=${planCode}`;
}

function promotionUploadMaterial(planCode: string, towerId: string) {
  return `/activity-manage/detail/act-manage/act-room/venueDetail/sub-venueMaterialUpload?planCode=${planCode}&towerId=${towerId}`;
}

function promotionManualUploadMaterial(planCode: string) {
  return `/activity-manage/detail/act-manage/act-room/venueDetail/sub-venueMaterialUpload?planCode=${planCode}`;
}

function promotionEditMaterial(planCode: string, towerId: string, materialCode: string) {
  const towerIdext = towerId ? '&towerId=' + towerId : '';
  return `/activity-manage/detail/act-manage/act-room/venueDetail/sub-venueMaterialedit?planCode=${planCode}&materialCode=${materialCode}${towerIdext}`;
}

type PoolDetailParams = {
  planCode: string;
  planName: string;
  poolId: string;
  poolName: string;
};

// 常规流程（非涅槃流程）商品池详情
function promotionNormalGoodlsPoolDetail({ planCode, planName, poolId, poolName }: PoolDetailParams) {
  return `/activity-manage/pooldetail?planCode=${planCode}&planName=${planName}&poolid=${poolId}&poolName=${poolName}`;
}

// 日常活动下的流程---------------------------------------------

// 新建会场活动
function myCreateCreateRoomActivity(params: any = {}) {
  return formatUrl({ pathname: '/activity-manage/myCreate/acoreCreateRoomActivity', params });
}
// 编辑会场活动
function myCreateEditRoomActivity(roomId: string | number, activityId: string | number) {
  return `/activity-manage/myCreate/acoreCreateRoomActivity?roomId=${roomId}&activityId=${activityId}`;
}
// 会场详情-素材收选
function myCreateActivityDetailMaterials(activityId: string | number) {
  return `/activity-manage/myCreate/daily-activities-manager/materials?activityId=${activityId}`;
}

// 会场详情-商品策略
function myCreateActivityDetailStrategy(activityId: string | number) {
  return `/activity-manage/myCreate/daily-activities-manager/strategy?activityId=${activityId}`;
}

// 日常活动-会场报名
function myCreateActivityReceiptRoomList(params: any) {
  return formatUrl({ pathname: '/activity-manage/myCreate/pools/roomlist', params });
}

// 日常活动-综促报名
function myCreateZongcuActivityReceipt(params: any) {
  return formatUrl({
    pathname: '/activity-manage/myCreate/zongcuActivity/myJoin/detail/activityEnroll/detail',
    params,
  });
}
// 日常活动-盘货收品报名
function myCreatePhSignUp(params: any) {
  return formatUrl({
    pathname: '/ph/phActivityDetail/enroll/signUp',
    params,
  });
}

/** ******************************************************** */

// 频道列表
function channelList(channelId: string) {
  return `/channel-service/position/${channelId}`;
}

// 频道-创建开放报名流程
function channelOpentRegisterCreate(channelId: string) {
  return `/channel-service/activity/create-open-register-act?channelId=${channelId}`;
}

// 频道-编辑开发报名流程
function channelOpentRegisterEdit(planCode: string, channelId: string) {
  return `/channel-service/activity/edit-open-register-act?planCode=${planCode}&channelId=${channelId}`;
}

// 频道-开发报名活动的收品池活动详情
function channelCollectionPoolList(planCode: string, entry: number, activityId: string) {
  return `/channel-service/activity/collection-pool-list/pools?planCode=${planCode}&entry=${entry}&activityId=${activityId}&from=acore`;
}

//频道-开发报名活动活动信息
function channelCollectionPoolListActInfo(planCode: string) {
  return `/channel-service/activity/collection-pool-list/activity-info?planCode=${planCode}`;
}
//频道-创建会场活动流程
function channelActRoomCreate(channelId: string) {
  return `/channel-service/activity/create-actRoom-act?channelId=${channelId}`;
}
//频道-编辑会场活动流程
function channelActRoomEdit(planCode: string, channelId: string) {
  return `/channel-service/activity/edit-actRoom-act?planCode=${planCode}&channelId=${channelId}`;
}
//频道-效果数据
function channelPerformanceData(planCode: string, entry: number, activityId: string) {
  return `/channel-service/activity/collection-pool-list/pools/effectdata?entry=${entry}&activityId=${activityId}&planCode=${planCode}&from=acore`;
}
//频道-流程数据
function channelProcessData(planCode: string, userType: number, activityId: string) {
  return `/channel-service/activity/collection-pool-list/pools/manage/activityData/detail?activityId=${activityId}&userType=${userType}&planCode=${planCode}&from=acore`;
}

// 频道-京东秒杀
function channelJdms() {
  return '/channel-service/jdms';
}

function channelActivityDetail(planCode: string) {
  return `/channel-service/activity/detail?planCode=${planCode}`;
}

// 活动详情商品池
function channelActivityDetailCommodityPool(planCode: string) {
  return `/channel-service/activity/detail/commodity-pool-manage?planCode=${planCode}`;
}

function channelActivityDetailInfo(planCode: string) {
  return `/channel-service/activity-detail?planCode=${planCode}`;
}

function channelActivityCreate(channelId?: string) {
  return `/channel-service/activity/create${channelId ? '?channelId=' + channelId : ''}`;
}

function channelActivityEdit(planCode: string) {
  return `/channel-service/activity/create?planCode=${planCode}`;
}

// 大促活动的征品详情
function channelNiePanZPDetail(planCode: string, activityId: string /* 征品活动ID */) {
  return `/channel-service/activity/detail/commodity-pool-manage/collection?planCode=${planCode}&activityId=${activityId}`;
}

function channelNiePanStartZP({ planCode, mainPoolId, shopPoolId, activityName }: StartZpParamsType) {
  return `/channel-service/activity/detail/commodity-pool-manage/collection?name=${activityName}&mainPoolId=${mainPoolId}&shopPoolId=${shopPoolId}&planCode=${planCode}`;
}

// 会场详情
function channelVenueDetail(planCode: string, towerId: string) {
  return `/channel-service/activity/detail/act-manage/act-room/venueDetail?towerId=${towerId}&planCode=${planCode}`;
}

// 会场列表
function channelVenue(planCode: string) {
  return `/channel-service/activity/detail/act-manage/act-room/activityVenue?planCode=${planCode}`;
}

// 会场提报创建收品池
function channelTiBaoVenueCreate(extPathname: string) {
  return `/channel-service/activity/detail/act-manage/act-room/page${extPathname}`;
}

// 会场提报设置收品池
function channelTiBaoVenueEdit(extPathname: string) {
  return `/channel-service/activity/detail/act-manage/act-room/page${extPathname}`;
}

// 会场提报资质设置
function channelTiBaoQuaSetting(extPathname: string) {
  return `/channel-service/activity/detail/act-manage/act-room/qua/page${extPathname}`;
}

// 会场提报场次设置
function channelTiBaoVenueSetting(extPathname: string) {
  return `/channel-service/activity/detail/act-manage/act-room/list${extPathname}`;
}

// 子活动管理/综促活动
function channelZCActivity(planCode: string) {
  return `/channel-service/activity/detail/act-manage/zongcu?planCode=${planCode}`;
}

// 创建综促活动
function channelCreateZCActivity(planCode: string, activityType: string) {
  return `/channel-service/activity/detail/act-manage/zongcu/create/activityManage/create?activity_type=${activityType}&planCode=${planCode}`;
}

// 综促活动资质设置
function channelZCQualificationSetting(planCode: string, activityId: string) {
  return `/channel-service/activity/detail/act-manage/zongcu/zongcuDetail/activityManage/qualificationSetting?activity_id=${activityId}&planCode=${planCode}`;
}

// 综促资源分配
function channelZCResourceAllocation(planCode: string, activityId: string) {
  return `/channel-service/activity/detail/act-manage/zongcu/zongcuDetail/activityManage/resourceAllocation?activity_id=${activityId}&planCode=${planCode}`;
}

// 资源详情
function channelZCResourceDetail(planCode: string, activityId: string) {
  return `/channel-service/activity/detail/act-manage/zongcu/zongcuDetail/activityManage/detail?activity_id=${activityId}&flow_type=0&planCode=${planCode}`;
}

// 去到素材底池设置
function channelMaterialPoolSet(planCode: string) {
  return `/channel-service/activity/detail/act-manage/act-room/materialPoolSet?planCode=${planCode}`;
}

// 去到素材底池编辑
function channelMaterialPoolEdit(planCode: string) {
  return `/channel-service/activity/detail/act-manage/act-room/materialPoolEdit?planCode=${planCode}`;
}

function channelMaterialManage(planCode: string) {
  return `/channel-service/activity/detail/act-manage/act-room/materialManage?planCode=${planCode}`;
}

function channelUploadMaterial(planCode: string, towerId: string) {
  return `/channel-service/activity/detail/act-manage/act-room/venueDetail/sub-venueMaterialUpload?planCode=${planCode}&towerId=${towerId}`;
}

function channelManualUploadMaterial(planCode: string) {
  return `/channel-service/activity/detail/act-manage/act-room/venueDetail/sub-venueMaterialUpload?planCode=${planCode}`;
}

function channelEditMaterial(planCode: string, towerId: string, materialCode: string) {
  const towerIdext = towerId ? '&towerId=' + towerId : '';
  return `/channel-service/activity/detail/act-manage/act-room/venueDetail/sub-venueMaterialedit?planCode=${planCode}&materialCode=${materialCode}${towerIdext}`;
}

// 行业频道-资源位报名
function channelResourceSignUp(params: any) {
  return formatUrl({
    pathname: '/channel-service/position/resource-detail/material-collection/distribute/roomlist',
    params,
  });
}

// 行业频道-资源位报名-收品池聚合
function channelResourceSignUpRoomList(params: any) {
  return formatUrl({
    pathname: '/channel-service/position/resource-detail/apply-roomList',
    params,
  });
}

// 行业频道-综促报名
function channelZongcuSignUp(params: any) {
  const { channelId, ...other } = params;
  return formatUrl({
    pathname: `/channel-service/position/${channelId}/cuxiao-play-and-detail/activityEnroll/detail`,
    params: other,
  });
}

// 常规流程（非涅槃流程）商品池详情
function channelNormalGoodlsPoolDetail({ planCode, planName, poolId, poolName }: PoolDetailParams) {
  return `/channel-service/pooldetail?planCode=${planCode}&planName=${planName}&poolid=${poolId}&poolName=${poolName}`;
}

// 平台营销阵地 - 素材管理所有地址 ----------------------------------------------------------
// 平台营销阵地-阵地详情页
function platformDetail(channelId: string) {
  return `/platform-marketing/${channelId}`;
}
//平台营销阵地-资源位报名
function platformMarketingResourceSignUp(params: any) {
  return formatUrl({
    pathname: '/platform-marketing/resource-detail/material-collection/distribute/roomlist',
    params,
  });
}
// 资源位报名--新收品池聚合页
function platformMarketingResourceRoomList(params: any) {
  return formatUrl({
    pathname: `/platform-marketing/resource-detail/apply-roomList`,
    params,
  });
}
// 平台营销阵地-综促报名
function platformMarketingZongcuSignUp(params: any) {
  const { channelId, ...other } = params;
  return formatUrl({
    pathname: `/platform-marketing/${channelId}/cuxiao-play-and-detail/activityEnroll/detail`,
    params: other,
  });
}
// 平台营销阵地 - 素材策略
function materialPoolManage(channelId: string) {
  return `${getModuleRootPath()}/${channelId}/material-pool-manage`;
}

// 平台营销阵地 - 素材策略-门槛规则-设置
function materialPoolRuleNew(channelId: string, poolId: string, ruleId: string, query?: string) {
  // let url = `${getModuleRootPath()}/${channelId}/material-poolrule-new?planCode=${channelId}&poolId=${poolId}&ruleId=${ruleId}`;
  const cquery = killEmptyPath(`poolId=${poolId}&ruleId=${ruleId}`);
  const showquery = cquery ? `planCode=${channelId}&${cquery}` : `planCode=${channelId}`;
  return `${getModuleRootPath()}/${channelId}/material-poolrule-new?${showquery}${query || ''}`;
}
// 会场 - 素材策略-门槛规则-设置
function dailyPoolRule(query: string) {
  // let url = `${getModuleRootPath()}/${channelId}/material-poolrule-new?planCode=${channelId}&poolId=${poolId}&ruleId=${ruleId}`;
  return `/activity-manage/myCreate/daily-activities-manager/pool-rule?${query}`;
}
// 会场提报场次设置
function platformTiBaoVenueSetting(extPathname: string) {
  return `/platform-marketing/resource-detail/material-collection/scene${extPathname}`;
}
// 会场提报场次设置
function dailyTiBaoVenueSetting(extPathname: string) {
  return `/activity-manage/myCreate/daily-activities-manager/scene${extPathname}`;
}

// 平台营销阵地 - 素材策略 - 商品策略 - 新建
function goodsStrategyNew(channelId: string) {
  return `${getModuleRootPath()}/${channelId}/goods-strategy-new/#/flow-field/create-job?planCode=${channelId}&promotionActivityId=${channelId}`;
}

// 平台营销阵地 - 素材策略 - 商品策略 - 详情
function goodsStrategyDetail({
  name,
  channelId,
  jid,
  createdBy,
  formCreate = false,
  aid = '',
}: {
  name: string; //策略名称
  channelId: string;
  jid: string;
  createdBy: string;
  formCreate: boolean;
  aid: string;
}) {
  let url = '';
  if (formCreate) {
    // 新建完成以后过来的，传aid
    url = `${getModuleRootPath()}/${channelId}/goods-strategy-detail/#/flow-field/field-inventory?planCode=${channelId}&aid=${aid}&jid=${jid}&createdBy=${createdBy}&name=${name}`;
  } else {
    // 列表页面点击的去详情，传promotionActivityId
    url = `${getModuleRootPath()}/${channelId}/goods-strategy-detail/#/flow-field/field-inventory?planCode=${channelId}&promotionActivityId=${channelId}&jid=${jid}&createdBy=${createdBy}&name=${name}`;
  }
  return url;
}

// 平台营销阵地 - 素材策略 - 促销商品策略 - 新建
function saleStategyNew(channelId: string, zongcuActivityType: string, promotionStrategy: string) {
  return `${getModuleRootPath()}/${channelId}/new-stategy-create/activityManage/create?planCode=${channelId}&tab=create&activity_type=${zongcuActivityType}&promotionStrategy=${promotionStrategy}&channelId=${channelId}`;
}

// 平台营销阵地 - 素材策略 - 促销商品策略 - 详情
function saleStategyDetail(
  channelId: string,
  zongcuActivityType: string,
  promotionStrategy: string,
  activity_id: string,
  tab: string, //详情【tab=detail】、和管理【tab=manage】
  name: string, //策略名称
  id: string, //策略id
  activityStatus: string, //活动状态【1-"活动编辑",2-"资质设置",3-"权限分配",4-"活动上线",5-"系统数据同步"】
  outerId: string //活动id
) {
  const newPromotionStrategy = Number(promotionStrategy) === 5 ? 1 : 2;
  let url = '';
  if (activityStatus && Number(activityStatus) < 3 && newPromotionStrategy === 1) {
    url = `${getModuleRootPath()}/${channelId}/sale-stategy-detailManage/activityManage/stategySetting/#/integration/yx-promotion?planCode=${channelId}&tab=${tab}&activityStatus=${activityStatus}&outId=${channelId}&activityType=9&uniqueId=um_${outerId}&activity_type=${zongcuActivityType}&promotionStrategy=${newPromotionStrategy}&channelId=${channelId}&activity_id=${activity_id}&id=${id}&name=${name}`;
  } else {
    url = `${getModuleRootPath()}/${channelId}/sale-stategy-detailManage/activityManage/detail?planCode=${channelId}&tab=${tab}&activityStatus=${activityStatus}&activity_type=${zongcuActivityType}&promotionStrategy=${newPromotionStrategy}&channelId=${channelId}&activity_id=${activity_id}&id=${id}&name=${name}`;
  }

  return url;
}

// 平台营销阵地 - 素材策略 - 促销商品策略 - 管理
function saleStategyManage(
  channelId: string,
  zongcuActivityType: string,
  promotionStrategy: string,
  activity_id: string,
  tab: string, //详情【tab=detail】、和管理【tab=manage】
  name: string, //策略名称
  id: string //策略id
) {
  const newPromotionStrategy = Number(promotionStrategy) === 5 ? 1 : 2;
  const url = `${getModuleRootPath()}/${channelId}/sale-stategy-detailManage/activityManage/detail?planCode=${channelId}&tab=${tab}&tab_key=5&activity_type=${zongcuActivityType}&promotionStrategy=${newPromotionStrategy}&channelId=${channelId}&activity_id=${activity_id}&name=${name}`;
  return url;
}
// 日常活动 - 品店策略所有地址 ----------------------------------------------------------
// 日常活动 - 品店策略 - 商品策略 - 列表
function dailyGoodsStrategyList(activityId: string) {
  return `/activity-manage/myCreate/daily-activities-manager/strategy?activityId=${activityId}`;
}

// 日常活动 - 品店策略 - 商品策略 - 新建
function dailyGoodsStrategyNew(roomId: string, activityId: string) {
  return `/activity-manage/myCreate/daily-activities-manager/strategy-new/#/flow-field/create-job?activityId=${activityId}&promotionActivityId=${roomId}`;
}

// 日常活动 - 品店策略 - 商品策略 - 详情
function dailyGoodsStrategyDetail({
  activityId,
  name,
  roomId,
  jid,
  createdBy,
  formCreate = false,
  aid = '',
}: {
  activityId: string;
  name: string; //策略名称
  roomId: string;
  jid: string;
  createdBy: string;
  formCreate: boolean;
  aid: string;
}) {
  let url = '';
  if (formCreate) {
    // 新建完成以后过来的，传:aid
    url = `/activity-manage/myCreate/daily-activities-manager/strategy-daily-good-detail?activityId=${activityId}&jobId=${jid}#/flow-field/field-inventory?aid=${aid}&jid=${jid}&name=${name}&createdBy=${createdBy}`;
  } else {
    // 列表页面点击的去详情，传:promotionActivityId
    url = `/activity-manage/myCreate/daily-activities-manager/strategy-daily-good-detail?activityId=${activityId}&jobId=${jid}#/flow-field/field-inventory?promotionActivityId=${roomId}&jid=${jid}&name=${name}&createdBy=${createdBy}`;
  }
  return url;
}

// 日常活动 - 品店策略 - 商品策略 - 触达配置【第一步：素材触达设置】
function dailyGoodsStrategyTouchSet(activityId: string, roomId: string, endTime: string, item: { [key: string]: any }) {
  return `/activity-manage/myCreate/daily-activities-manager/strategy-set?activityId=${activityId}&roomId=${roomId}&jobId=${item?.jobId}&jobName=${item?.jobName}&endTime=${endTime}&ruleId=${item?.ruleId}`;
}

// 日常活动 - 品店策略 - 商品策略 - 触达配置【第二步：触达商品范围设置】【第二步只要是第一步选了部分触达才进行】
function dailyGoodsStrategyRangeSet(
  jobName: string,
  activityId: string,
  roomId: string,
  jobId: string,
  ruleId: string,
  uniqueId: string,
  disable: boolean
) {
  if (!ruleId || ruleId === 'undefined') {
    return `/activity-manage/myCreate/daily-activities-manager/strategy-goods-range?activityId=${activityId}&roomId=${roomId}&jobId=${jobId}#/integration/yx-promotion?activityId=${activityId}&roomId=${roomId}&jobId=${jobId}&jobName=${jobName}&uniqueId=${uniqueId}&outId=${roomId}&activityType=11&disable=${
      disable || false
    }`;
  } else {
    return `/activity-manage/myCreate/daily-activities-manager/strategy-goods-range?activityId=${activityId}&roomId=${roomId}&jobId=${jobId}#/integration/yx-promotion?activityId=${activityId}&roomId=${roomId}&jobId=${jobId}&jobName=${jobName}&uniqueId=${uniqueId}&outId=${roomId}&ruleId=${ruleId}&activityType=11&disable=${
      disable || false
    }`;
  }
}

// 日常活动 - 品店策略 - 商品策略 - 触达记录/触达详情【第一个tab】后续tab在路由router.config里面跳转
function dailyGoodsStrategyTouchDetail(
  activityId: string,
  roomId: string,
  jobId: string,
  ruleId: string,
  noticeScope: string
) {
  if (!ruleId || ruleId === 'undefined') {
    return `/activity-manage/myCreate/daily-activities-manager/strategy-touch-detail/touch-state?noticeScope=${noticeScope}&activityId=${activityId}&roomId=${roomId}&jobId=${jobId}&disable=true`;
  } else {
    return `/activity-manage/myCreate/daily-activities-manager/strategy-touch-detail/touch-state?noticeScope=${noticeScope}&activityId=${activityId}&roomId=${roomId}&jobId=${jobId}&ruleId=${ruleId}&disable=true`;
  }
}

export default {
  // toDataPanelParticipantDataActivityDetail,
  toDataPanelRealTimeData,
  toDataPanelAnalysisReport,
  toDataPanelRoomFlowDataList,
  toDataPanelRoomFlowDataDetail,
  // --------------------------
  toActivityManageProSalesData,
  activityList,
  merchantRoomMyCreate,
  merchantActivityCreate,
  merchantActivityEdit,
  merchantActivityDetail,
  merchantActivityDetailInfo,
  merchantActivityInventory,
  merchantActivityWare,
  merchantActivityMyWare,
  merchantPromotionMyCreate,
  merchantMyJoinVenue,
  merchantVenueDetailPoolList,
  merchantPromotionToZongcuSignUp,
  // ----------------------
  promotionActivityDetail,
  promotionActivityDetailCommodityPool,
  promotionActivityCreate,
  promotionActivityEdit,
  promotionActivityDetailInfo,
  promotionNiePanZPDetail,
  promotionNiePanStartZP,
  promotionVenueDetail,
  promotionVenue,
  promotionTiBaoVenueCreate,
  promotionTiBaoVenueEdit,
  promotionTiBaoQuaSetting,
  promotionTiBaoVenueSetting,
  promotionZCActivity,
  promotionCreateZCActivity,
  promotionZCQualificationSetting,
  promotionZCResourceAllocation,
  promotionZCResourceDetail,
  promotionMaterialPoolSet,
  promotionMaterialPoolEdit,
  promotionMaterialManage,
  promotionUploadMaterial,
  promotionManualUploadMaterial,
  promotionEditMaterial,
  promotionNormalGoodlsPoolDetail,
  //-----------------------------
  myCreateCreateRoomActivity,
  myCreateEditRoomActivity,
  myCreateActivityDetailMaterials,
  myCreateActivityDetailStrategy,
  myCreateActivityReceiptRoomList,
  myCreateZongcuActivityReceipt,
  myCreatePhSignUp,
  // ------------------------------------
  channelProcessData,
  channelPerformanceData,
  channelActRoomEdit,
  channelActRoomCreate,
  channelOpentRegisterCreate,
  channelCollectionPoolListActInfo,
  channelOpentRegisterEdit,
  channelCollectionPoolList,
  channelJdms,
  channelList,
  channelActivityDetail,
  channelActivityDetailCommodityPool,
  channelActivityCreate,
  channelActivityEdit,
  channelActivityDetailInfo,
  channelNiePanZPDetail,
  channelNiePanStartZP,
  channelVenueDetail,
  channelVenue,
  channelTiBaoVenueCreate,
  channelTiBaoVenueEdit,
  channelTiBaoQuaSetting,
  channelTiBaoVenueSetting,
  channelZCActivity,
  channelCreateZCActivity,
  channelZCQualificationSetting,
  channelZCResourceAllocation,
  channelZCResourceDetail,
  channelMaterialPoolSet,
  channelMaterialPoolEdit,
  channelMaterialManage,
  channelUploadMaterial,
  channelManualUploadMaterial,
  channelEditMaterial,
  channelNormalGoodlsPoolDetail,
  channelResourceSignUp,
  channelResourceSignUpRoomList,
  channelZongcuSignUp,
  // ------------------------------------
  platformDetail,
  platformMarketingResourceSignUp,
  platformMarketingResourceRoomList,
  platformMarketingZongcuSignUp,
  materialPoolManage,
  materialPoolRuleNew,
  dailyPoolRule,
  platformTiBaoVenueSetting,
  dailyTiBaoVenueSetting,
  goodsStrategyNew,
  goodsStrategyDetail,
  // ----------------------------------
  dailyGoodsStrategyList,
  dailyGoodsStrategyNew,
  dailyGoodsStrategyDetail,
  dailyGoodsStrategyTouchSet,
  dailyGoodsStrategyRangeSet,
  dailyGoodsStrategyTouchDetail,
  saleStategyNew,
  saleStategyDetail,
  saleStategyManage,
};
